import * as React from "react";
import {
  Empty,
  Form,
  FormListFieldData,
  Input,
  Switch,
  Typography,
} from "antd";
import { VerticalLayout } from "src/components/VerticalLayout";
import { MultiLangFields } from "src/components/MultiLangFields";
import { trimRequired } from "src/common/validationRules/trimRequired";
import { t } from "i18next";
import styles from "./ServFuncsEditor.module.less";
import { EdServiseCommonInfo } from "../ServSettingsForm";
import { EdServFunc } from "../../ObjectForm2/EdBusinessService";

const fkey = (key: keyof EdServiseCommonInfo) => key;

export const ServFuncsEditor: React.FC = () => (
  <Form.List name={fkey("functions")}>
    {(fields) => (
      <VerticalLayout>
        {fields.length === 0 && (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="У бизнес-сервиса нет функций"
          />
        )}
        {fields.length > 0 &&
          fields.map((field) => <ServFuncField {...field} />)}
      </VerticalLayout>
    )}
  </Form.List>
);

const ServFuncField: React.FC<FormListFieldData> = ({ name }) => {
  const funcFieldKey = (fieldKey: keyof EdServFunc) => [name, fieldKey];
  const form = Form.useFormInstance<EdServiseCommonInfo>();
  const funcName: string = Form.useWatch(
    [fkey("functions"), ...funcFieldKey("functionName")],
    form,
  );
  const active: boolean = Form.useWatch(
    [fkey("functions"), ...funcFieldKey("active")],
    form,
  );
  return (
    <>
      <div className={styles.itemBox}>
        <div className={styles.itemContent}>
          <Form.Item name={funcFieldKey("active")}>
            <Switch />
          </Form.Item>
          <div className={styles.funcName}>
            <Typography.Text type="secondary">{t(funcName)}</Typography.Text>
          </div>
        </div>
      </div>
      {active && (
        <>
          <Form.Item
            name={funcFieldKey("displayFunctionName")}
            label="Название функции в меню дополнительных функций"
            rules={[trimRequired()]}
          >
            <Input allowClear />
          </Form.Item>
          <MultiLangFields basePath={funcFieldKey("displayNameLoc")} />
        </>
      )}
    </>
  );
};
